import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';
import 'rxjs/observable/forkJoin';

@Injectable()
export class ApiProvider {

  private baseUrl: string;

  private selectedEvent: any;

  constructor(public http: HttpClient, private translateService: TranslateService) {

  }

  public initialize() {

    let instance = this;

    return this.http.get("assets/config.json").map(function(response: any) {

      instance.baseUrl = response.baseUrl;

      let url = instance.baseUrl + "Event/" + response.EventId + "?Language=" + (instance.translateService.currentLang == "eng"? 1: 0);
      let headers = new HttpHeaders().set("Content-Type", "application/json");

      instance.translateService.onLangChange.subscribe(() => {

        let url = instance.baseUrl + "Event/" + response.EventId + "?Language=" + (instance.translateService.currentLang == "eng"? 1: 0);

        instance.http.get(url, {headers: headers}).subscribe((res) => {

          Object.assign(instance.selectedEvent, res);

          console.log(instance.selectedEvent);

        });
  
      })

      return instance.http.get(url, {headers: headers}).do(function(response: any) {

        instance.setEvent(response);

      }).map(function() {

        return response;

      });

    });

  }

  //#region Event

  public getEvents() {

    let url = this.baseUrl + "Event";
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return this.http.get(url, {headers: headers});

  }

  public setEvent(event: any) {

    this.selectedEvent = event;

  }

  public getSelectedEvent() {

    return this.selectedEvent;

  }

  //#endregion

  //#region Registration

  public getRegistrationFields() {

    let url = this.baseUrl + "System/GuestRegistration";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  public postt2Image(base64Image: string) {

    let url = this.baseUrl + "Guest/Image";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.post(url, base64Image, {headers: headers});

  }

  public postFaceImage(base64Image: string, cardNumber: string) {

    let url = this.baseUrl + "Guest/Face/" + cardNumber;
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.post(url, base64Image, {headers: headers});

  }

  public postRegistrationForm(formData) {

    let url = this.baseUrl + "Guest";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let body = {
      Company: formData.Company,
      OfficeAddress: formData.OfficeAddress,
      Gender: formData.Gender,
      FirstName: formData.FirstName,
      LastName: formData.LastName,
      JobTitle: formData.JobTitle,
      Mobile: formData.Mobile,
      Email: formData.Email,
      // FoodAllergy: formData.FoodAllergy,
      Language: formData.Language,
      Source: formData.Source,
      SeminarSession: formData.SeminarSession,
      Luncheon: formData.Luncheon,
      Source3: formData.Source3,
      t0: formData.t0,
      t1: formData.t1,
      t2: formData.t2,
      t3: formData.t3,
      t6: formData.t6,
      // t8: formData.t8,
      t9: formData.t9
    };

    return this.http.post(url, body, {headers: headers});

  }

  public getTerms(language: number) {

    let url = this.baseUrl + "Event/Terms?language=" + language;
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  //#endregion

  //#region Check In

  public indentifyFace(base64Image: string) {

    let url = this.baseUrl + "Guest/Face/Identify";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.post(url, base64Image, {headers: headers});

  }

  public checkInGuest(cardNumber) {

    let url = this.baseUrl + "Guest/Action";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let body = {
      id: cardNumber,
      actionType: "CheckIn"
    }

    return this.http.put(url, body, {headers: headers});

  }

  public changeAttendance(cardNumber: string, oldStatus: number) {

    let url = this.baseUrl + "Guest/Status";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let newStatus: number;

    if(oldStatus == 0) {
      newStatus = -1;
    } else {
      newStatus = 0;
    }

    let body = {
      id: cardNumber,
      statusType: newStatus
    }

    return this.http.put(url, body, {headers: headers});

  }

  //#endregion

  //#region Survey

  public getSurveyFields() {

    let url = this.baseUrl + "System/Survey";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  public getQuestions() {

    let language;
    switch(this.translateService.currentLang) {

      case "cht": {

        language = 0;
        break;

      }
      case "eng": {

        language = 1;
        break;

      }

    }

    let url = this.baseUrl + "Survey/Questions?language=" + language;
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  public getAnswers(cardNumber: string) {

    let language;
    switch(this.translateService.currentLang) {

      case "cht": {

        language = 0;
        break;

      }
      case "eng": {

        language = 1;
        break;

      }

    }

    let url = this.baseUrl + "Survey?language=" + language;
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let body = {
      id: cardNumber
    };

    return this.http.put(url, body, {headers: headers});

  }

  public postSurvey(cardNumber: string, questionSource: any[], surveyFormData: any) {

    let url = this.baseUrl + "Survey";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let answers: any[] = [];

    questionSource.forEach((question) => {

      switch(question.QuestionType) {

        case "select": {

          let answer = {
            Seq: question.Seq,
            AnswerSeq: surveyFormData[question.Seq].AnswerSeq,
            Answer: surveyFormData[question.Seq].Comment,
            ParentSurveyAnswerSeq: question.ParentSurveyAnswerSeq,
            ParentSurveyQuestionSeq: question.ParentSurveyQuestionSeq,
          };

          answers.push(answer);

          break;

        }
        case "multiple-select": {

          surveyFormData[question.Seq].filter(a => a.Checked).forEach((a) => {

            let answer = {
              Seq: question.Seq,
              AnswerSeq: a.AnswerSeq,
              Answer: a.Comment,
              ParentSurveyAnswerSeq: question.ParentSurveyAnswerSeq,
              ParentSurveyQuestionSeq: question.ParentSurveyQuestionSeq,
            };

            answers.push(answer);

          });

          break;

        }
        case "ranking": {

          surveyFormData[question.Seq].forEach((a) => {

            let answer = {
              Seq: question.Seq,
              AnswerSeq: a.AnswerSeq,
              Answer: surveyFormData[question.Seq].indexOf(a),
              ParentSurveyAnswerSeq: question.ParentSurveyAnswerSeq,
              ParentSurveyQuestionSeq: question.ParentSurveyQuestionSeq,
            };

            answers.push(answer);

          });

          break;

        }
        case "range": {

          let answerLeft = {
            Seq: question.Seq,
            AnswerSeq: 0,
            Answer: surveyFormData[question.Seq],
            ParentSurveyAnswerSeq: question.ParentSurveyAnswerSeq,
            ParentSurveyQuestionSeq: question.ParentSurveyQuestionSeq,
          };

          let answerRight = {
            Seq: question.Seq,
            AnswerSeq: 1,
            Answer: 100 - surveyFormData[question.Seq],
            ParentSurveyAnswerSeq: question.ParentSurveyAnswerSeq,
            ParentSurveyQuestionSeq: question.ParentSurveyQuestionSeq,
          };

          answers.push(answerLeft);
          answers.push(answerRight);

          break;

        }
        case "multiple-range": {

          surveyFormData[question.Seq].forEach((a) => {

            let answer = {
              Seq: question.Seq,
              AnswerSeq: a.AnswerSeq,
              Answer: a.Value
            };

            answers.push(answer);

          });

          break;

        }
        case "multiple-range-100": {

          surveyFormData[question.Seq].forEach((a) => {

            let answer = {
              Seq: question.Seq,
              AnswerSeq: a.AnswerSeq,
              Answer: a.Value
            };

            answers.push(answer);

          });

          break;

        }
        case "text": {

          let answer = {
            Seq: question.Seq,
            AnswerSeq: 0,
            Answer: surveyFormData[question.Seq]
          };

          answers.push(answer);

          break;

        }

      }

    });

    let body = {
      id: cardNumber,
      answers: answers
    };

    return this.http.post(url, body, {headers: headers});

  }

  //#endregion

  //#region Gift Redemption

  public redeemGift(cardNumber: string) {

    let url = this.baseUrl + "Guest/Action";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let body = {
      id: cardNumber,
      actionType: "GiftRedeem"
    }

    return this.http.put(url, body, {headers: headers});

  }

  //#endregion

  //#region Guest

  public getGuestFields() {

    let url = this.baseUrl + "System/Guest";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  public getGuest(cardNumber: string) {

    let url = this.baseUrl + "Guest/Action";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let body = {
      id: cardNumber,
      actionType: "Enquiry"
    }

    return this.http.put(url, body, {headers: headers});

  }

  //#endregion

  //#region Dashboard

  public getActionCounts() {

    let url = this.baseUrl + "Dashboard";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  public getSalesTeamsCounts() {

    let url = this.baseUrl + "Dashboard/SalesTeam";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  public getDateCounts() {

    let url = this.baseUrl + "Dashboard/Interval";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  //#endregion

  //#region Search

  public getGuests() {

    let url = this.baseUrl + "Guest";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    return this.http.get(url, {headers: headers});

  }

  public getCustomFields() {

    let instance = this;

    let url = this.baseUrl + "Event/Fields";
    let headers = new HttpHeaders().set("Content-Type", "application/json").set("EventId", this.selectedEvent.EventId);

    let chtSubscription = this.http.get(url + "?language=0", {headers: headers}).do(function(response){

      instance.translateService.setTranslation("cht", response, true);
      return response;

    });

    let engSubscription = this.http.get(url + "?language=1", {headers: headers}).do(function(response){

      instance.translateService.setTranslation("eng", response, true);
      return response;

    });

    return Observable.forkJoin([chtSubscription, engSubscription], function(response){

      return Object.keys(response);

    });

  }

  //#endregion

}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts